<greco-alert
  [config]="{
    title: agreement.signedAgreementTitle + ' is Unsigned',
    type: $any('DANGER'),
    description: 'This agreement must be signed before making purchases or booking classes'
  }"
>
  <button mat-flat-button color="warn" slot="buttons" (click)="sign()">Sign</button>
</greco-alert>
